import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgBamLogo = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 40 40' aria-labelledby={titleId} {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path d='M27.57,19.26c1.48-1.28,2.43-3.16,2.43-5.26,0-3.86-3.19-7-7.1-7H7v8h16c.55,0,1-.45,1-1s-.45-1-1-1h-14v-4h13.9c2.77,0,5.1,2.29,5.1,5s-2.34,5-5.1,5H7v2h18.68c2.83,0,5.32,2.34,5.32,5s-2.48,5-5.32,5H9v-4h17c.55,0,1-.45,1-1s-.45-1-1-1H7v8h18.68c3.97,0,7.32-3.21,7.32-7,0-3.17-2.34-5.92-5.43-6.74Z' />
  </svg>
);
export default SvgBamLogo;
